// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"ba65231e","356":"a51ae278","886":"e005e270"}[chunkId] + ".chunk.css";
};